export default __webpack_public_path__ + "static/media/timeline-down-arrow.276a35ea.svg";